<template>
  <div class="by-dialog-style">
    <el-dialog
      :title="title"
      :visible="visible"
      :close-on-click-modal="false"
      
      @close="handleCancel"
      :width="width"
      :top="top"
      :modal-append-to-body="true"
    >
      <!-- 头部 -->
      <!-- <div class="by-dialog-header" >
        <div class="by-dialog-header-title">
          <span>{{ title }}</span>
        </div>
      </div>
 -->
      <div class="by-dialog-main">
        <div class="by-dialog-main__tip">
          <img
            v-if="type == 'warning'"
            src="../../../../../static/newStatic/img/message-warning@2x.png"
            alt="message-warning"
            width="16"
            height="16"
          />
          <img
            v-if="type == 'error'"
            src="../../../../../static/newStatic/img/message-error@2x.png"
            alt="message-error"
            width="16"
            height="16"
          />
          <img
            v-if="type == 'success'"
            src="../../../../../static/newStatic/img/message-success@2x.png"
            alt="message-success"
            width="16"
            height="16"
          />
          <p>{{ message }}</p>
        </div>
        <div class="by-dialog-main__btn">
          <button
            v-if="showCancelButton"
            class="cancel-btn-style by-button--default2"
            @click="handleCancel"
          >
            <span>{{ cancelButtonText }}</span>
          </button>
          <button
            v-if="showConfirmButton"
            class="confirm-btn-style by-button--primary"
            @click="handleConfirm"
          >
            <span>{{ confirmButtonText }}</span>
          </button>
        </div>
      </div>
    </el-dialog>
    <!-- <div class="dialog-bg" v-if="visible"></div> -->
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: "提示",
    },
    titleCenterName: {
      type: String,
      required: false,
      default: "",
    },
    width: {
      type: String,
      required: false,
      default: "400px",
    },
    top: {
      type: String,
      required: false,
      default: "35vh",
    },
    message: {
      // 显示时文字时传文字，图片传地址
      type: [String, Array],
      required: false,
      default: "",
    },
    type: {
      // 显示类型，
      type: String,
      default: "warning", // success, warning, error
    },

    confirmButtonText: {
      // 确定按钮文字
      type: String,
      default: "确定",
    },
    cancelButtonText: {
      // 取消按钮文字
      type: String,
      default: "取消",
    },
    showCancelButton: {
      // 是否显示取消按钮
      type: Boolean,
      default: true,
    },
    showConfirmButton: {
      // 是否显示确认按钮
      type: Boolean,
      default: true,
    },
  },
  components: {},
  data() {
    return {
      visible: false,
      resolve: null,
      reject: null,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    show() {
      this.visible = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    handleConfirm() {
      this.visible = false;
      if (this.resolve) {
        this.resolve(true);
      }
    },
    handleCancel() {
      this.visible = false;
      if (this.resolve) {
        this.resolve(false);
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../../../common/css/common.scss";
.by-dialog-style {
  @extend .el-dialog-default;
  .el-dialog__wrapper {
    z-index: 10003 !important;
  }

  // .v-modal {
  //   // z-index: 10002 !important;
  //   display: none;
  //   opacity: 0;
  // }
  .el-dialog__header {
    padding: 16px 24px;
    height: 56px !important;
    box-sizing: border-box;

    .el-dialog__title {
      font-size: 14px !important;
      font-family: PingFangSC-Regular, PingFang SC !important;
      font-weight: 400 !important;
      color: #333333 !important;
      line-height: 22px !important;
    }

    .el-dialog__headerbtn {
      top: 16px !important;

      .el-dialog__close {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        font-weight: 400 !important;
        font-size: 13px !important;
        color: #777 !important;
        transition: all 0.3s !important;
        &:hover {
          background: #ebebeb !important;
          border-radius: 4px !important;
        }
      }
    }
  }

  .el-dialog__footer {
    padding: 0 !important;
  }

  .by-dialog-header {
    position: relative;

    .by-dialog-header-title {
      position: absolute;
      top: -40px;
      left: 128px;
      padding: 0 8px;
      height: 24px;
      background: rgba(0, 70, 185, 0.08);
      border-radius: 8px;

      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0046b9;
        line-height: 24px;
      }
    }
  }

  .by-dialog-main {
    padding: 16px 24px 24px 24px;

    .by-dialog-main__tip {
      display: flex;

      img {
        position: relative;
        top: 3px;
      }

      p {
        margin-left: 8px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 22px;
        text-align: left;
        font-style: normal;
      }
    }

    .by-dialog-main__btn {
      margin-top: 48px;
      display: flex;
      justify-content: flex-end;

      .default-btn-style {
        display: flex;
        align-items: center;
        justify-content: center;
        outline: none;
        border: none;
        padding: 5px 16px;
        height: 32px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #dddddd;

        span {
          display: inline-block;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
      }

      .cancel-btn-style {
        @extend .default-btn-style;
        span {
          color: #333333;
        }
      }

      .confirm-btn-style {
        margin-left: 16px;
        @extend .default-btn-style;
        background: #0046b9;
        border: 1px solid transparent;
        span {
          color: #ffffff;
        }
      }
    }
  }

  .dialog-bg {
    @extend .dialog-model;
    z-index: 10002 !important;
  }

  & .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .image-center {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/backstageManagement/public/ByMessageBox/ByMessageBox.vue